<div class="data-wrapper">
    <div class="label">{{label || 'No Label'}}:</div>
    <div class="value">{{value || 'No Value'}}</div>
</div>